import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ProgressBar } from 'react-bootstrap';

export class ProgressCell extends Component {
  getColor() {
    const diff = Math.abs(this.props.actual - this.props.expected);

    if (diff >= 30) return 'danger';
    if (diff >= 20) return 'warning';

    return 'success';
  }

  render() {
    const color = this.getColor();
    const percentage = this.props.actual;

    return (
      <ProgressBar
        style={{ margin: 0, padding: 0 }}
        striped
        now={percentage}
        label={`${percentage}%`}
        bsStyle={color}
      />
    );
  }
}

ProgressCell.propTypes = {
  actual: PropTypes.number.isRequired,
  expected: PropTypes.number.isRequired,
};
